import React from 'react';
import PropTypes from 'prop-types';
import Select, { components } from 'react-select';

import FieldTemplate from '../FieldTemplate';
import DropdownIcon from '../../../../public/static/icons/navigation-chevron-down.svg';

class SelectField extends React.Component {
  // Reference to the select field.
  selectRef = null;

  // Special field adapter for react-final-form library which connects
  // react-select component to the form.
  SelectFieldAdapter = ({
    input: { value, onChange, onFocus, onBlur },
    meta,
    onOptionSelect = () => {},
    ...rest
  }) => {
    return (
      <Select
        value={value}
        onChange={(selectedOption) => {
          onChange(selectedOption);
          onOptionSelect(selectedOption);
        }}
        onFocus={onFocus}
        onBlur={onBlur}
        blurInputOnSelect
        ref={(ref) => {
          this.selectRef = ref;

          const { autoFill = true } = this.props;
          // Preventing autofilling.
          if (!autoFill && this.selectRef) {
            this.selectRef.inputRef.autocomplete = 'new-password';
          }
        }}
        {...rest}
      />
    );
  };

  // Custom template for "SelectContainer" component of react-select library.
  SelectContainer = ({ children, hasValue, selectProps, ...props }) => {
    const classes = ['data-hj-suppress'];

    if (hasValue) {
      classes.push('has-value');
    }

    if (selectProps.menuIsOpen) {
      classes.push('opened');
    }

    if (selectProps.menuPlacement === 'top') {
      classes.push('menu-top');
    }

    return (
      <components.SelectContainer {...props} className={classes.join(' ')}>
        {children}
      </components.SelectContainer>
    );
  };

  SingleValue =
    (dataAnalytics) =>
    // eslint-disable-next-line
    ({ innerProps, ...props }) => {
      return (
        <components.SingleValue
          {...props}
          innerProps={Object.assign({}, innerProps, { 'data-analytics': dataAnalytics || null })}
        />
      );
    };

  render() {
    const { options, defaultValue = {}, label = '', name = '', ...props } = this.props;
    return (
      <FieldTemplate
        component={this.SelectFieldAdapter}
        type="select"
        name={name}
        value={defaultValue}
        options={options}
        label={label}
        components={{
          SelectContainer: this.SelectContainer,
          DropdownIndicator: () => <DropdownIcon />,
          SingleValue: this.SingleValue(props['data-analytics']),
        }}
        className="select"
        classNamePrefix="select"
        style="normal"
        {...props}
      />
    );
  }
}

SelectField.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  ).isRequired,
  defaultValue: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  }),
  onOptionSelect: PropTypes.func,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  info: PropTypes.string,
  autoFill: PropTypes.bool,
};

export default SelectField;
